import Vue from "vue";
import Vuex from "vuex";

import age from "./modules/age";
import brand from "./modules/brand";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		hostUrl: process.env.VUE_APP_hostUrl,
		fileHostUrl: process.env.VUE_APP_fileHostUrl,
	},
	mutations: {},
	actions: {},
	modules: {
		age,
		brand,
	},
});
